/* eslint-disable import/prefer-default-export */
import {
  UPDATE_APPLICATION_RANK_REQUEST,
  UPDATE_APPLICATION_RANK_SUCCESS,
  UPDATE_APPLICATION_RANK_FAILURE,
  NEW_APPLICATION_RANK,
  NEW_APPLICATION_RANK_DRAG,
} from './actionTypes';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';
// import { SAVE_APPLICATION_SUCCESS } from '../constants';

const updateApplicationRankRequest = () => ({
  type: UPDATE_APPLICATION_RANK_REQUEST,
});

const updateApplicationRankSuccess = () => ({
  type: UPDATE_APPLICATION_RANK_SUCCESS,
});

const updateApplicationRankFailure = ({ error }) => ({
  type: UPDATE_APPLICATION_RANK_FAILURE,
  error,
});

const newApplicationRank = ({ applicationId, id: directoryProgram, schoolId, rank, respData }) => ({
  type: NEW_APPLICATION_RANK,
  payload: {
    applicationId,
    id: directoryProgram,
    schoolId,
    rank,
    respData,
  },
});

const groupUpdateApplicationRankRequest = () => ({
  type: UPDATE_APPLICATION_RANK_REQUEST,
});

const groupUpdateApplicationRankSuccess = () => ({
  type: UPDATE_APPLICATION_RANK_SUCCESS,
});

const groupUpdateApplicationRankFailure = ({ error }) => ({
  type: UPDATE_APPLICATION_RANK_FAILURE,
  error,
});

/* const newGroupApplicationRank = ({ reduxData }) => ({
  type: NEW_APPLICATION_RANK,
  payload: {

  },
});

*/

export const groupUpdateApplicationRank = data => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { user, intl } = getState();
  const { applicationId } = user;
  const { locale } = intl;
  const saveUrl = `${locale}/api/${apiVersion}/application/${applicationId}/application-programs/rank/`;
  dispatch(groupUpdateApplicationRankRequest());
  return fetch(saveUrl, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'post',
    body: JSON.stringify(data),
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(() => {
      // dispatch(newGroupApplicationRank(reduxData));
      dispatch(groupUpdateApplicationRankSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(groupUpdateApplicationRankFailure({ error }));
    });
};

export const exportnewApplicationDragDrop = ranks => ({
  type: NEW_APPLICATION_RANK_DRAG,
  payload: {
    ranks,
  },
});

export const updateApplicationRank = (directoryProgram, schoolId, rank, savedApplicationId) => async (
  dispatch,
  getState,
  { fetch },
) => {
  const { apiVersion } = getState().runtime;
  const { applicationId } = getState().user;
  const { locale } = getState().intl;
  const data = {
    directory_program: directoryProgram,
    application: applicationId,
    guardian: getState().user.guardianId,
    rank,
  };

  // FIND SOME OTHER WAY TO GET LANGUAGES FROM DJANGO
  const saveUrl = `${locale}/api/${apiVersion}/application/${applicationId}/application-programs/${savedApplicationId}/`;
  const urlParameters = Object.entries(data)
    .map(e => `${encodeURIComponent(e[0])}=${encodeURIComponent(e[1])}`)
    .join('&');
  dispatch(updateApplicationRankRequest());

  return fetch(saveUrl, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'PUT',
    body: urlParameters,
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(respData => {
      dispatch(
        newApplicationRank({
          applicationId,
          id: directoryProgram,
          schoolId,
          rank,
          respData,
        }),
      );
      dispatch(updateApplicationRankSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(updateApplicationRankFailure({ error }));
    });
};
